import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const PaymentMethodList = lazy(() => import('../Pages/PaymentMethodList'));
const PaymentMethodAdd = lazy(() => import('../Pages/PaymentMethodAdd'));
const PaymentMethodEdit = lazy(() => import('../Pages/PaymentMethodEdit'));
const PaymentMethodView = lazy(() => import('../Pages/PaymentMethodView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/payment-method.scss';

function PaymentMethodRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/settings/payment-methods"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <PaymentMethodList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <PaymentMethodList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <PaymentMethodAdd history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <PaymentMethodEdit history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/payment-methods/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <PaymentMethodView history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default PaymentMethodRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
